<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.system_order_no"
        size="small"
        placeholder="系统订单号"
        clearable
        style="width: 220px"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <el-select
        class="filter-item"
        v-model="listQuery.operation_type"
        size="small"
        placeholder="操作类型"
        clearable
        style="width: 150px"
      >
        <el-option label="处理" value="handle" />
        <el-option label="回退" value="revoke" />
        <el-option label="重新处理" value="re_handle" />
      </el-select>
      <el-button
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button size="small" @click="handleReset">重置</el-button>
    </div>

    <el-table v-loading="loading" :data="list" border fit size="small">
      <el-table-column align="center" label="操作日志ID" width="90" prop="id" />
      <el-table-column
        align="center"
        label="系统订单号"
        width="170"
        prop="system_order_no"
      />
      <el-table-column align="center" label="操作类型" width="110">
        <template slot-scope="scope">
          <el-tag
            :type="operationTagType(scope.row.operation_type)"
            size="small"
          >
            {{ operationTypeLabel(scope.row.operation_type) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="系统成本" width="120">
        <template slot-scope="scope">
          <render-field :field="scope.row.fields?.actual_total_rate" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="渠道结算额" width="130">
        <template slot-scope="scope">
          <render-field :field="scope.row.fields?.actual_channel_money" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="实际离店时间" width="140">
        <template slot-scope="scope">
          <render-field :field="scope.row.fields?.actual_end_travel_date" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="供应商订单状态" width="120">
        <template slot-scope="scope">
          <render-field
            :field="formatOrderState(scope.row.fields?.order_state)"
          />
        </template>
      </el-table-column>
      <el-table-column align="center" label="系统订单状态" width="120">
        <template slot-scope="scope">
          <render-field
            :field="
              formatSystemOrderStatus(scope.row.fields?.system_order_status)
            "
          />
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作人类型" width="90">
        <template slot-scope="scope">{{
          operatorTypeLabel(scope.row.operator_type)
        }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        label="操作时间"
        width="160"
        prop="created_at"
      />
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

/* 字段渲染组件：有修改显示红绿块，无修改显示绿块 */
const RenderField = {
  functional: true,
  props: {
    field: { type: Object, default: null },
  },
  render(h, ctx) {
    const field = ctx.props.field
    if (!field) {
      return h('span', '-')
    }
    if (
      field.old_value !== undefined &&
      field.old_value !== null &&
      field.old_value !== ''
    ) {
      return h(
        'div',
        {
          style: {
            display: 'flex',
            'flex-direction': 'column',
            gap: '4px',
            'align-items': 'center',
          },
        },
        [
          h('el-tag', { props: { type: 'danger' } }, field.old_value),
          h('el-tag', { props: { type: 'success' } }, field.new_value),
        ],
      )
    }
    return h('el-tag', { props: { type: 'success' } }, field.new_value || '-')
  },
}

export default {
  name: 'OperationLog',
  components: {
    RenderField,
  },
  props: {
    reconciliationLogId: { type: [String, Number], default: '' },
    systemOrderNo: { type: String, default: '' },
    targetType: { type: String, default: 'jin_jiang' },
    dialogMode: { type: Boolean, default: false },
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      listQuery: {
        page: 1,
        limit: 10,
        system_order_no: '',
        operation_type: '',
      },
      targetType: 'jin_jiang',
    }
  },
  created() {
    // dialogMode 下从 props 读取，否则从路由查询参数读取
    if (this.dialogMode) {
      this.listQuery.system_order_no = this.systemOrderNo
    } else {
      const query = this.$route.query
      if (query.reconciliation_log_id) {
        this.reconciliationLogId = query.reconciliation_log_id
      }
      if (query.system_order_no) {
        this.listQuery.system_order_no = query.system_order_no
      }
      if (query.target_type) {
        this.targetType = query.target_type
      }
    }
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      const params = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
        reconciliation_log_id: this.reconciliationLogId || undefined,
        system_order_no: this.listQuery.system_order_no || undefined,
        operation_type: this.listQuery.operation_type || undefined,
      }
      const baseUrl =
        this.targetType === 'long_teng'
          ? '/api/backend/longTeng/reconciliation-log/operation-list'
          : this.targetType === 'sui_chuan'
          ? '/api/backend/suiChuan/reconciliation-log/operation-list'
          : this.targetType === 'li_cheng'
          ? '/api/backend/liCheng/reconciliation-log/operation-list'
          : '/api/backend/reconciliation-log/operation-list'
      request({
        url: baseUrl,
        method: 'get',
        params,
      })
        .then((response) => {
          this.list = (response.data || []).map((item) => {
            // 根据 snapshot_log.changes 构建 fields，供 RenderField 使用
            item.fields = {}
            const changes = item.snapshot_log?.changes || []
            const snapshot = item.snapshot_log?.snapshot || {}
            changes.forEach(({ field, old_value, new_value }) => {
              item.fields[field] = { old_value, new_value }
            })
            // 未变化的字段从 snapshot 取当前值
            ;[
              'actual_total_rate',
              'actual_channel_money',
              'actual_end_travel_date',
              'order_state',
              'system_order_status',
            ].forEach((key) => {
              if (!item.fields[key] && snapshot[key] !== undefined) {
                item.fields[key] = { new_value: snapshot[key] }
              }
            })
            return item
          })
          this.total = response.data.length
        })
        .catch(() => {
          this.$message.error('获取操作日志失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.fetchData()
    },
    handleReset() {
      this.listQuery.system_order_no = ''
      this.listQuery.operation_type = ''
      this.handleFilter()
    },
    operationTypeLabel(type) {
      const map = {
        handle: '处理',
        revoke: '回退',
        re_handle: '重新处理',
      }
      return map[type] || type || '-'
    },
    operationTagType(type) {
      const map = {
        handle: 'success',
        revoke: 'danger',
        re_handle: 'warning',
      }
      return map[type] || 'info'
    },
    operatorTypeLabel(type) {
      const map = {
        1: '管理员',
        2: 'API',
        3: '系统',
        4: '员工',
      }
      return map[type] || type || '-'
    },
    formatOrderState(field) {
      if (!field) return field
      const map = {
        1: '预订成功',
        2: '已取消',
        3: '预订未到',
        4: '已入住',
        5: '已完成',
      }
      const result = { ...field }
      if (result.old_value)
        result.old_value = map[result.old_value] || result.old_value
      if (result.new_value)
        result.new_value = map[result.new_value] || result.new_value
      return result
    },
    formatSystemOrderStatus(field) {
      if (!field) return field
      const map = {
        100: '下单待处理',
        101: '下单成功',
        102: '下单失败',
        103: '下单确认中',
        201: '取消订单成功',
        202: '取消订单失败',
        203: '取消订单中',
      }
      const result = { ...field }
      if (result.old_value)
        result.old_value = map[result.old_value] || result.old_value
      if (result.new_value)
        result.new_value = map[result.new_value] || result.new_value
      return result
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.fetchData()
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  padding-bottom: 16px;
  .filter-item {
    margin-bottom: 10px;
    margin-right: 10px;
    vertical-align: top;
  }
}
.pagination-container {
  margin-top: 16px;
  text-align: center;
}
</style>
